import React, { useContext } from 'react'

import './header.scss'

import { UIContext } from '../../contexts/ui'

function Header(props) {
	const { setTheme } = useContext(UIContext)
	const onThemeChange = (event) => {
		setTheme(event.target.value)
	}

	return (
		<header className='Header'>
			<h1>Ragnarok Prime Simulator</h1>
			<nav>
				<ul>
					{/* <li>Log In</li> */}
					<li>
						Choose theme :
						<select
							name='ThemeSelector'
							id='ThemeSelector'
							onChange={onThemeChange}
						>
							<option value={0}>Basic</option>
							<option value={1}>Scrambling kid</option>
							<option value={2}>Metal</option>
						</select>
					</li>
				</ul>
			</nav>
		</header>
	)
}

export default Header
